import { useRef, useEffect } from 'react';

function useDoubleEscape(_ref) {
  let {
    onClose,
    onShowFeedback,
    enabled = true,
    timeWindow = 1000
  } = _ref;
  const firstPressRef = useRef(false);
  const timerRef = useRef(null);
  useEffect(() => {
    if (!enabled) {
      return;
    }
    const handleKeyDown = event => {
      if (event.key !== 'Escape') {
        return;
      }
      event.preventDefault();
      event.stopPropagation();
      if (!firstPressRef.current) {
        firstPressRef.current = true;
        onShowFeedback === null || onShowFeedback === void 0 ? void 0 : onShowFeedback(timeWindow);
        timerRef.current = setTimeout(() => {
          firstPressRef.current = false;
        }, timeWindow);
      } else {
        if (timerRef.current) {
          clearTimeout(timerRef.current);
          timerRef.current = null;
        }
        firstPressRef.current = false;
        onClose();
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, [enabled, onClose, onShowFeedback, timeWindow]);
}

export { useDoubleEscape };
